import type { Question } from "@/types/questionnaire/question";
import type { QuestionnaireRead } from "@/types/questionnaire/questionnaire";

type QuestionnaireIdentity = Pick<QuestionnaireRead, "title" | "slug">;

export function isOpdVitalsQuestionnaire(
  questionnaire: QuestionnaireIdentity,
): boolean {
  const title = questionnaire.title?.trim().toLowerCase();
  const slug = questionnaire.slug?.trim().toLowerCase();
  return title === "vitals" || slug === "vitals";
}

export function isOptionalOpdVitalsPainQuestion(
  questionnaire: QuestionnaireIdentity,
  question: Pick<Question, "link_id" | "text">,
): boolean {
  if (!isOpdVitalsQuestionnaire(questionnaire)) return false;

  const linkId = question.link_id
    .trim()
    .toLowerCase()
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ");
  const text = question.text.trim().toLowerCase().replace(/\s+/g, " ");

  return (
    linkId === "pain" || linkId === "pain score" || text.includes("pain score")
  );
}

export function normalizeOpdVitalsQuestionnaire(
  questionnaire: QuestionnaireRead | undefined,
): QuestionnaireRead | undefined {
  if (!questionnaire || !isOpdVitalsQuestionnaire(questionnaire)) {
    return questionnaire;
  }

  const normalizeQuestion = (question: Question): Question => ({
    ...question,
    ...(question.questions
      ? { questions: question.questions.map(normalizeQuestion) }
      : {}),
    ...(isOptionalOpdVitalsPainQuestion(questionnaire, question)
      ? { required: false }
      : {}),
  });

  return {
    ...questionnaire,
    questions: questionnaire.questions.map(normalizeQuestion),
  };
}
